import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useLocale } from '@/modules/locale/model/locale';
import { transactionService } from '@/services/transaction';

export function useTransactionList() {
    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            locale: { type: 'string', default: '' },
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { localeSupportedOptions, getListSupported } = useLocale();

    const { list, total, fetchList } = useBaseListView({
        request: transactionService.text.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            loadInitialData: async () => await getListSupported(),
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            canFetch: () => {
                if (StringUtils.isEmpty(query.locale)) {
                    list.value = [];
                    total.value = 0;
                    return false;
                }

                return true;
            }
        }
    });

    return { list, total, query, fetchList, localeSupportedOptions };
}
